module.exports = __webpack_public_path__ + "static/media/feat-barons-img2.8b5ee36d.jpg";